export const ActionTypes = {
  REQUEST: "ADMIN_FETCH_HABIT_HABITS_REQUEST",
  SUCCESS: "ADMIN_FETCH_HABIT_HABITS_SUCCESS",
  FAILURE: "ADMIN_FETCH_HABIT_HABITS_FAILURE",

  SUCCESS_SINGLE: "ADMIN_FETCH_HABIT_HABIT_SUCCESS",
  UPDATE_SUCCESS: "ADMIN_UPDATE_HABIT_HABIT_SUCCESS",
  CREATE_SUCCESS: "ADMIN_CREATE_HABIT_HABIT_SUCCESS",
  DELETE_SUCCESS: "ADMIN_DELETE_HABIT_HABIT_SUCCESS",
}

export interface IHabit {
  id: number;
  type: number;
  name: string;
  is_pre_filling: boolean;
  subcategory: number;
  subcategory_name: string;
  category: number;
  category_name: string;
  area: number;
  area_name: string;
}

interface NormalizedEntities {
  [key: string]: IHabit;
}

export interface IState {
  entities: NormalizedEntities;
  ids: string[];
  count: number;
  loading: boolean;
  error: any;
}
